export const DynamicFields = [
    { label: "heading", description: "Heading section" },
    { label: "title",description: "Page title", maxLength: 100 },
    { label: "summary", description: "Product description", maxLength: 250 },
    { label: "cta", description: "Call-to-action text"}
    // 500 more fields
]

